import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';

type NavBarSubmenuProperties = {
    icon: ReactNode;
    title: string | ReactNode;
};

export const SidebarNavSubmenu: FunctionComponent<PropsWithChildren<NavBarSubmenuProperties>> = ({ title, icon, children }) => {
    return (
        <li>
            <Disclosure>
                <DisclosureButton
                    className={'group flex w-full items-center gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-400 hover:bg-gray-800 hover:text-white'}
                >
                    {icon}
                    {title}
                    <div className={'flex grow justify-end'}>
                        <ChevronDownIcon className="w-5 content-end group-data-[open]:rotate-180" />
                    </div>
                </DisclosureButton>
                <DisclosurePanel>{children}</DisclosurePanel>
            </Disclosure>
        </li>
    );
};
